import { render } from "./InfoBlockMsg.vue?vue&type=template&id=dc93a6b6"
import script from "./InfoBlockMsg.vue?vue&type=script&lang=js"
export * from "./InfoBlockMsg.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Develop\\web\\notigo_base\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__